import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { IReportVoice, IReportVoiceParams, IResponseDataTable } from '../../interfaces/apis';
import packageSmsApis from '../../../../services/packageSmsApis';
import dayjs from 'dayjs';

const DEFAULT_PARAMS: IReportVoiceParams = {
  page: 1,
  size: 10,
  shopId: undefined,
  startDate: dayjs().subtract(7, 'day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetReportVoice = (isLazy = false) => {
  const [params, setParams] = useState<IReportVoiceParams>(DEFAULT_PARAMS);

  const [data, setData] = useState<IResponseDataTable<IReportVoice>>();
  const [loading, setLoading] = useState(false);

  const fetchData = async (paramsSubmit: IReportVoiceParams) => {
    setLoading(true);
    try {
      const response: AxiosResponse<{ data: IResponseDataTable<IReportVoice> }> = await packageSmsApis.getReportVoice({
        ...paramsSubmit,
        shopId: paramsSubmit.shopId ? paramsSubmit.shopId : undefined,
        startDate: dayjs(paramsSubmit.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(paramsSubmit.endDate).format('MM-DD-YYYY'),
      });

      setData(response.data.data);
    } catch (error) {
      setData(undefined);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isLazy) {
      fetchData(params);
    }
  }, [params, isLazy]);

  return {
    data,
    loading,
    params,
    setParams,
  };
};

export default useGetReportVoice;
